module.exports = __webpack_public_path__ + "img/4.a5d287df.jpg";